import { RoleEnum } from '@zeus/index'
import { useBranding } from '~/helpers/branding/branding-context'
import { useAuth } from '~/helpers/store/auth'

function Footer() {
  const { appName, footerText } = useBranding()
  const isAdmin = useAuth(state => state.payload?.role === RoleEnum.Admin)

  return (
    <footer className="p-5 text-center">
      {footerText || `${appName} © ${new Date().getFullYear()}`}
      {isAdmin && (
        <>
          <span className="mx-2 text-muted-foreground">·</span>
          <span className="text-sm text-muted-foreground">{`v${__APP_VERSION__}`}</span>
        </>
      )}
    </footer>
  )
}

export default Footer
